<template>
	<div class="catalog-categories" :style="`color: ${theme.base}`">
		<div class="catalog-categories-container">
			<div class="catalog-categories-container-scroll">
				<button
					v-for="category in categories"
					:key="category.id"
					class="catalog-categories-tag"
					:class="{ 'is-selected': category.isSelected }"
					:style="category.isSelected ?
						`background-color: ${theme.secondary}; color: ${theme.base};` : `color: ${theme.secondary};`"
					type="button"
					@click="$emit('select-category', category)"
				>
					{{ category.title }}
				</button>
			</div>
		</div>
		<div class="text-min-price" v-if="showAmountMin">*El monto mínimo de pedido es {{ currencySymbol }}{{ amountMin | round }} </div>
	</div>
</template>

<script>
	export default {
		name: 'catalog-categories',
		props: {
			amountMin: [Number, String],
			categories: {
				default: () => [],
				type: Array,
			},
			currencySymbol: String,
			showAmountMin: {
				default: false,
				type: Boolean,
			},
			theme: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.catalog-categories {
		background-color: rgba(215, 237, 238, 1);
		padding: 14px 5px 12px;

		@media (min-width: 936px) {
			background-color: currentColor;
			padding: 23px 5px 28px;
		}

		&-container {
			background-color: rgba(2, 151, 155, 0.23);
			border-radius: 20.5px;
			height: 39px;
			max-width: 100%;
			overflow-y: scroll;

			@media (min-width: 936px) {
				border-radius: 24px;
				height: 48px;
			}

			&-scroll {
				display: inline-flex;
				flex-direction: column;
				flex-wrap: wrap;
				height: 100%;
			}
		}

		&-tag {
			height: 100%;
			padding: 0px 13px;
			width: fit-content;
			width: -moz-fit-content;

			@media (min-width: 936px) {
				padding: 0px 78px;
			}

			&.is-selected {
				border-radius: 20.5px;
			}
		}
	}

	.text-min-price {
		color: #494949;
		font-size: 16px;
		margin-top: 12px;
		padding-left: 15px;

		@media (min-width: 936px) {
			font-size: 18px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/catalog/catalog-categories.vue